import moment from 'moment';

/* eslint-disable max-len */
const regexes = {
  sortCode: /^([0-9]{6})$/,
  accountNo: /^([0-9]{8})$/,
  companyRegistrationNumber: /^(SC|sc|sC|Sc)\d{6}$|[0-9]{8}$/,
  numberWithoutZero: /^([1-9][0-9]*)$/,
  alphanumeric: /^((^[a-z]{2}\.\s)?((\w|\w')\s[a-z]{2}\.\s)?([a-z0-9]+-[a-z0-9]+)?([0-9]\/[0-9]{0,2})?([a-z]{1}'[a-z]+|\s[a-z]{1}'[a-z]+|[a-z]'\s[a-z]+|[a-z]'[s]\s[a-z]+)*([a-z0-9]+\s{0,1})?)+(\w{2,}'|[\w]|\w{2,}'[s])$/i,
  alphanumericPunctuationSpace: /^([a-z0-9\-_, ./£$?!&:]*)$/i,
  alphanumericSpace: /^([a-z0-9\-_, .$!&:]*)$/i,
  alphanumericSpecial: /^(?![\d]{10}$)([a-zA-Z0-9.@!#$&'*=+\-_]{6,70})$/i,
  email: /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/,
  password: /^((?=.*\d)(?=.*[a-zA-Z])(?=.*['!"$%^&*()_\-/+={}[\]@‘~#?|<>,.;:])[a-zA-Z\d¬'!"$%^&*()_\\\-/+={}[\]@~#?|<>,.;:]{8,16})$/,
  username: /^[a-zA-Z0-9]{6,16}$/,
  tel: /^[0-9]{11}$/,
  postcode: /^((GIR 0AA|X9 9RB|X9 9AA|X9 9BF|X9 9AJ|X9 9AB|X9 9TA|X9 9LG|X9 9BH|X9 9LF|X9 2TR|XE16 4QZ|XE11 1AA|XE98 1TL|XEP O11|XE99 3GG|XE0 2AQ|XE1A 1AA|XE18 3AN|XE7 4GJ|XE1P 2PR|XE2 7EJ|XE12 8JS|XE1H 9DW|XE 5GG|XE1X 7XA|XE1X 7XF|XE1 8NH|XE1 1RJ|XE1 1RN|XE1 1LE|XE24 99X|XE 0AA|XE12 8HJ)|((([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z])))) [0-9][A-Z]{2}))$/i,
  letterCode: /^([0-9]{10})$/,
  percentage: /^[1-9][0-9]?$|^100$/,
  linkcode: /^[0-9]{6}$/,
  date: /^((3[01]{1}|[012]{1}[0-9]{1})-((0[1-9]{1}|1[012]{1})))-(((19|18)[0-9]{2}|2[0-9]{3}))$/i,
  alphanumericSpecialUsername: /^([a-zA-Z0-9.@!#$&'*=+\-_]{6,70})$/i,
  cardNo: /^([0-9]{16})$/,
  accountName: /^(([a-z_,.?!&:$£&:/]+-[a-z_,.?!&:$£&:/]+)?([a-z]{1}'[a-z_,.?!&:$£&:/]+|\s[a-z]{1}'[a-z_,.?!&:$£&:/]+|[a-z0-9_,.?!&:$£&:/]\s[a-z_,.?!&:$£&:/]+|[a-z_,.?!&:$£&:/]'[s]\s[a-z_,.?!&:$£&:/]+)*([a-z0-9_,.?!&:$£&:/]+\s{0,1})?)+([\w|_,.?!&:$£&:/']{2,}|[\w]|[\w|_,.?!&:$£&:/']{2,}'[s])$/i,
  alphaTwoSpaces: /^([a-z]+[-']*[a-z]+(\s(?!$))?){1,2}([a-z]+[-']*[a-z]+)*?$/i
};
/* eslint-enable max-len */

export const isValidEmailAddress = value => !regexes.email.test(value);
export const isValidUsername = value => !regexes.alphanumericSpecial.test(value);
export const isValidPassword = value => !regexes.password.test(value);
export const isYes = value => (value === 'Yes' ? true : false);
export const isCheck = value => (value && value.length !== 0 ? undefined : 'Required');
export const isTel = value => !regexes.tel.test(value);
export const isPercentage = value => !regexes.percentage.test(value);
export const isRequired = value => (value ? undefined : 'Required');
export const isLetterCodeValid = value => !regexes.letterCode.test(value);
export const isLinkCode = value => !regexes.linkcode.test(value);
export const isChecked = value => (value && value.isChecked === true ? undefined : 'Required');

export const isValidGlobalBehaviour = (value, type) => {
  if (!value) {
    return false;
  }
  const regExp = new RegExp(regexes[type]);
  return regExp.test(value);
};

export const isOptionalGlobalBehaviour = (value, type) => {
  const regExp = new RegExp(regexes[type]);
  return regExp.test(value);
};

export const isValidType = value => {
  if (!value) {
    return false;
  }
  const { dateField, monthField, yearField } = value;
  const date = `${dateField}-${monthField}-${yearField}`;
  return isValidGlobalBehaviour(date, 'date');
};

export const isDateValid = (DateField = {}) => {
  const { dateField, monthField, yearField } = DateField;
  if (!dateField || !monthField || !yearField) {
    return false;
  }
  if (!isValidType(DateField)) {
    return false;
  }
  const date = moment(`${yearField}-${monthField}-${dateField}`, 'YYYY-MM-DD', true);
  if (moment().diff(date, 'days') > 0 || moment().diff(date, 'days') === 0) {
    return date.isValid();
  }
  return false;
};

export const isExpiredDate = (DateField = {}) => {
  const { dateField, monthField, yearField } = DateField;
  if (!dateField || !monthField || !yearField) {
    return false;
  }
  if (!isValidType(DateField)) {
    return false;
  }
  const date = moment(`${yearField}-${monthField}-${dateField}`, 'YYYY-MM-DD', true);
  const currentDate = moment();
  if (date.diff(currentDate, 'days') > 0 || date.diff(currentDate, 'days') === 0) {
    return date.isValid();
  }
  return false;
};

export const isTradingLessThanSixMonths = (DateField = {}) => {
  const sixMonth = 6;
  const sixMonthsAgo = moment()
    .startOf('days')
    .subtract(sixMonth, 'months');
  const { dateField, monthField, yearField } = DateField;
  const tradingDuration = moment(`${dateField}-${monthField}-${yearField}`);
  if (
    moment(tradingDuration, 'DD-MM-YYYY').isAfter(sixMonthsAgo) ||
    moment(tradingDuration, 'DD-MM-YYYY').isSame(sixMonthsAgo)
  ) {
    return true;
  }
  return false;
};

export const isSortCodeValid = (sortField = {}) => {
  const { sortField1, sortField2, sortField3 } = sortField;
  const sortFieldValid = `${sortField1}${sortField2}${sortField3}`;
  if (isValidGlobalBehaviour(sortFieldValid, 'sortCode')) {
    return true;
  }
  return false;
};

export const isMonthYearDateValid = (DateField = {}) => {
  const { monthField, yearField } = DateField;
  if (!monthField || !yearField) {
    return false;
  }
  const date = moment(`${yearField}-${monthField}`, 'YYYY-MM', true);
  if (moment().diff(date, 'days') > 0) {
    return date.isValid();
  }
  return false;
};
export const convertToCamelCase = str => {
  return str
    .toLowerCase()
    .replace(/(?:(^.)|(\s+.))/g, match => match.charAt(match.length - 1).toUpperCase());
};
